import {
    PRECIO_JUSTO_UPDATE_CONFIGURATIONS_BEGIN,
    PRECIO_JUSTO_UPDATE_CONFIGURATIONS_SUCCESS,
    PRECIO_JUSTO_UPDATE_CONFIGURATIONS_FAILURE
} from './constants'
import { BFFAgent } from 'BFFAgent'

export function updateConfigurations(data) {
    return async dispatch => {
        dispatch({
            type: PRECIO_JUSTO_UPDATE_CONFIGURATIONS_BEGIN
        })
        const res = await BFFAgent.FairPrice.updateConfigurations(data)
        
        if (res?.id)
            dispatch({
                type: PRECIO_JUSTO_UPDATE_CONFIGURATIONS_SUCCESS,
                configuration: res
            })
        else
            dispatch({
                type: PRECIO_JUSTO_UPDATE_CONFIGURATIONS_FAILURE
            })
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case PRECIO_JUSTO_UPDATE_CONFIGURATIONS_BEGIN:
            return {
                ...state,
                actConfigurationError: null,
                actConfigurationPending: true,
            }
        case PRECIO_JUSTO_UPDATE_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                actConfiguration: action.configuration,
                actConfigurationError: null,
                actConfigurationPending: false,
            }
        case PRECIO_JUSTO_UPDATE_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                actConfigurationError: true,
                actConfigurationPending: false,
            }

        default:
            return state
    }
}
